<template>
    <div class="app">
        <!-- Removed isLoading on header so it doesn't disappear between page loads. -->
        <theme-header />

        <div class="wrap-page">
        <router-view :key="$route.path"
                     @pageLoaded="loadPage"/>

            <div v-if="!isLoading"
                 :class="['scroll-up', {'sticky-disabled': disabled, 'white-text': bgScrollUpIcon}]"
                 v-scroll-to="'.header'"

                 :style="{backgroundColor: bgScrollUpIcon}"
            >
                <font-awesome-icon :icon="longArrowUp"/>
            </div>
        </div>

        <transition
            @enter="showLoading"
            @leave="hideLoading"
        >
            <loading-page v-if="isLoading"/>
        </transition>

        <theme-footer v-if="!isLoading"/>
    </div>
</template>

<script>
    import ThemeHeader from './modules/header/ThemeHeader'
    import ThemeFooter from './modules/footer/ThemeFooter'
    import LoadingPage from './modules/includes/LoadingPage'
    import VueSticky from 'vue-sticky';
    import faLongArrowUp from '@fortawesome/fontawesome-pro-light/faLongArrowUp';
    import {EventBus} from "./utils/EventBus";


    export default {
        name: "App",
        components: {ThemeHeader, ThemeFooter, LoadingPage},
        data() {
            return {
                isLoading: true
            }
        },
        directives: {
            'sticky': VueSticky,
        },
        created() {
            EventBus.$on('runLoading', this.runLoading);
            window.$eventBus = EventBus;
        },
        beforeDestroy() {
            EventBus.$off('runLoading');
            window.$eventBus = null;
        },
        computed: {
            bgScrollUpIcon() {
                if (EventBus.bgScrollUpIcon === '') return false;
                return EventBus.bgScrollUpIcon;
            },
            longArrowUp() {
                return faLongArrowUp;
            },
            stickyTop() {
                return window.innerHeight - 56;
            },
            disabled() {
                return EventBus.distanceBottom < 450;
            },
            pageLoaded() {
                return EventBus.pageLoaded;
            },
        },
        methods: {
            loadPage() {
                this.isLoading = false;
            },
            showLoading(el, done) {
                TweenMax.fromTo(el,0.25, {opacity: 0}, {opacity:1,onComplete: done});
            },
            hideLoading(el, done) {
                let toOptions = {
                    delay: 0.15, opacity: 0,
                    onStart: () => { this.$scrollTo(`body`, 50) },
                    onComplete: done
                };

                TweenMax.fromTo(el, 0.25, {opacity: 1}, toOptions);
            },
            runLoading() {
                this.isLoading = true;
            }
        },
        watch: {
            $route: {
                deep: true,
                immediate: true,
                handler(val, oldVal) {
                    if (!this.$route.hash) this.isLoading = true
                }
            },
            pageLoaded: {
                deep: true,
                handler(val, oldVal) {
                    if (val) {
                        this.$scrollTo('.app');
                    }
                },
            },
        }
    }
</script>

<style lang="scss" scoped>

    .scroll-up {
        position: sticky;
        background-color: $color3;
        padding: 15px 22px 10px;
        color: $color1;
        width: 56px;
        cursor: pointer;
        z-index: 998;
        bottom: 20px;
        left: calc(100vw - 76px);
        right: auto;

        &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-color: rgba(#000, .4);
            transition: all .3s ease-in-out;
            opacity: 0;

        }

        &:hover::after {
            opacity: 1;
        }

        &.white-text {
            color: #fff;
        }

        &.sticky-disabled {
            /*top: calc(100% - 480px) !important;*/
        }

        @media (max-width: 600px) {
            right: -10px;
        }

        /deep/ svg {
            font-size: 25px;
            line-height: 25px;
        }
    }

</style>